/**
 * Logs exceptions with the server.
 *
 * Requires jQuery and JSON. Attempts to call $.backendErrorMsg() if possible,
 * otherwise falls back to a page redirect to an error message.
 *
 *
 *
 * See: https://developer.mozilla.org/en/DOM/window.onerror
 *
 * Note: I have attempted to generate a stacktrace using
 *  https://raw.github.com/eriwen/javascript-stacktrace/master/stacktrace.js
 * but cannot get it to work without bugging out. I suspect try-catch falls
 * apart in the window.onerror global error handler.
 *
 * Note: this behaves wierd, I have tested it but some things seem to throw it
 * off, like having your console open/being in debugging mode. Needs testing
 * with typical browser setups.
 *
 *
 *
 * TODO: move files to /js/backend/error/....
 */

var logErrorWithServer = function(ex){

};

window.onerror = function(errorMsg, url, lineNumber){

	var data = {
		message: errorMsg,
		url: url,
		lineNumber: lineNumber,
		isexternal: false
	};

	// We need to figure out whether or not this was caused by iBex
	var isIbexError = true;
	if(url.length > 0){
		if(!/^((https?:\/\/)?(.*)\.(seekom\.com|googleapis\.com)|\/albatross\/static)/.test(url)){
			// Is not a seekom URL, may be a browser extension interfering
			data.isexternal = true;
			isIbexError = false;
		}
	}

	// Log
	logErrorWithServer(data);

	// Show error message // TODO: why not jQuery?
	if(document && document.body && document.body.className && document.body.className.indexOf('display-errors') != -1){
		// environment with display-errors on
		console.error('window.onerror: (Full Handler) ', errorMsg, url, lineNumber);
	}else{
		// environment with display-errors off
		if(isIbexError){
			if($ && $.backendErrorMsg){
				$.backendErrorMsg();
			}else{
				window.location.href = '/error/msg?javascript&handler=full';
			}
		}
		else {
			// For non iBex errors, run things slightly differently, don't do the normal
			// popup message
			if($){
				$('#backend-error-msg-ext-js').show();
				return true;
			}
		}
	}

	// Allow default browser handling of uncaught exceptions
	return false;
};

// window.onunhandledrejection = function(data) {
// 	if(typeof Raven !== 'undefined' && Raven.isSetup()) {
//         // Raven.captureException(data.reason);
//     }
// };
